import React from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as DeleteIcon} from 'assets/svg/trash.svg';
import {ProductGroupIcon} from 'components/common/ProductGroupIcon';
import {Icon} from 'components/ui-kit/Icon';
import {IconButton} from 'components/ui-kit/IconButton';
import {ProductGroup} from 'core/constants/productGroups';

import {colors} from 'theme';
import {formatDate} from 'utils/date';

import {
    ProductSingleItemDescription,
    ProductSingleItemInfo,
    ProductSingleItemInfoName,
    ProductSingleItemRoot,
    ProductSingleItemText,
    ProductSingleItemType,
    ProductSingleItemControl,
} from '../styled';

export const ProductSingleItem = ({
    name,
    gtin,
    quantity,
    productGroupCode,
    manufacturingDate,
    expirationDate,
    batchNumber,
    onDelete,
}: {
    name: string;
    gtin: string;
    quantity: number;
    productGroupCode: ProductGroup;
    manufacturingDate?: string;
    expirationDate?: string;
    batchNumber?: string;
    onDelete: () => void;
}) => {
    const {t} = useTranslation();
    const isMedication = productGroupCode === 'MEDICATIONS';

    return (
        <ProductSingleItemRoot>
            <ProductSingleItemType>
                <ProductGroupIcon
                    style={{marginBottom: 0}}
                    width={16}
                    value={productGroupCode as ProductGroup}
                />
            </ProductSingleItemType>
            <ProductSingleItemInfo>
                <ProductSingleItemInfoName>{name}</ProductSingleItemInfoName>
                <ProductSingleItemDescription>
                    <ProductSingleItemText>
                        {t('pages.orders.form.productCode', {gtin})}
                    </ProductSingleItemText>
                    <ProductSingleItemText>
                        {t('pages.orders.form.quantityItem', {quantity})}
                    </ProductSingleItemText>
                    <ProductSingleItemText>
                        {t('pages.orders.form.fromTypeItem', {
                            type: 'My Products',
                        })}
                    </ProductSingleItemText>
                    {isMedication && (
                        <>
                            <ProductSingleItemText>
                                {t('pages.orders.form.manufacturingDate')}:{' '}
                                {manufacturingDate ? formatDate(manufacturingDate) : '-'}
                            </ProductSingleItemText>
                            <ProductSingleItemText>
                                {t('pages.orders.form.expirationDate')}:{' '}
                                {expirationDate ? formatDate(expirationDate) : '-'}
                            </ProductSingleItemText>
                            <ProductSingleItemText>
                                {t('pages.orders.form.batchNumber')}: {batchNumber || '-'}
                            </ProductSingleItemText>
                        </>
                    )}
                </ProductSingleItemDescription>
            </ProductSingleItemInfo>
            <ProductSingleItemControl>
                <IconButton
                    onClick={() => {
                        onDelete();
                    }}
                    icon={
                        <Icon
                            source={DeleteIcon}
                            width={20}
                            height={20}
                            fillColor={colors.danger}
                        />
                    }
                />
            </ProductSingleItemControl>
        </ProductSingleItemRoot>
    );
};
